module.exports = __webpack_public_path__ + "static/img/about_banner_pc.06a87f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_banner_pc.png
// module id = vAd+
// module chunks = 1